import React, { useEffect } from 'react';
import { animated, useSpring } from '@react-spring/web'
import { useAppSelector } from '@store/hooks';
import { selectCurrentCategory } from '@store/mainReducer';

function AnimatedDiv({
    children,
  }: {
    children: React.ReactNode;
  }) { 
  const [styles, api] = useSpring(() => ({
    opacity: 0,
    config: {
      duration: 100
     }
    }), []
  );
  const currentCategory = useAppSelector(selectCurrentCategory);

  useEffect(() => {
    api.start({
      to: async (next) => {
        await next({ opacity: 0.5 });
        await next({ opacity: 0.6 });
        await next({ opacity: 0.7 });
        await next({ opacity: 0.8 });
        await next({ opacity: 0.9 });
        await next({ opacity: 1 });
      },
          config: {
            duration: 100
           }
      
    })
  }, [currentCategory, api]);

  return (
    // @ts-ignore
    <animated.span
      // onClick={handleClick}
      style={{
        ...styles,
        overflow: "hidden",
      }}>
      {children}
    </animated.span>
  )
}

export default AnimatedDiv;